// extracted by mini-css-extract-plugin
export var phoneNumberInput = "_f0-0";